<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="[
      'icon-circle',
      { disabled: disabled },
      !bypassDefaultColor && circleStyle === 'line' ? `color-stroke-${color}` : '',
      !bypassDefaultColor && circleStyle !== 'line' ? `color-fill-${color}` : '',
    ]"
    v-bind="$attrs"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      v-if="circleStyle === 'full'"
      d="M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13Z"
    />
    <path
      v-else-if="circleStyle === 'line'"
      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      v-else-if="circleStyle === 'dash'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3309 10.5004C12.7564 9.76488 13 8.91088 13 8C13 7.08912 12.7564 6.23512 12.3309 5.4996L14.062 4.49799C14.659 5.52976 15 6.72809 15 8C15 9.27191 14.659 10.4702 14.062 11.502L12.3309 10.5004ZM10.5004 3.66914L11.502 1.93802C10.4702 1.34105 9.27191 1 8 1C6.72809 1 5.52976 1.34105 4.49799 1.93802L5.4996 3.66914C6.23512 3.24357 7.08912 3 8 3C8.91088 3 9.76488 3.24357 10.5004 3.66914ZM3.66914 5.4996C3.24357 6.23512 3 7.08912 3 8C3 8.91088 3.24357 9.76488 3.66914 10.5004L1.93802 11.502C1.34105 10.4702 1 9.27191 1 8C1 6.72809 1.34105 5.52976 1.93802 4.49799L3.66914 5.4996ZM5.4996 12.3309L4.49799 14.062C5.52976 14.659 6.72809 15 8 15C9.27191 15 10.4702 14.659 11.502 14.062L10.5004 12.3309C9.76488 12.7564 8.91088 13 8 13C7.08912 13 6.23512 12.7564 5.4996 12.3309Z"
    />
    <path
      v-else
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9048 8.97581C12.9673 8.66021 13 8.33393 13 8C13 7.66607 12.9673 7.33979 12.9048 7.02419L14.8668 6.63605C14.9544 7.0788 15 7.53506 15 8C15 8.46494 14.9544 8.9212 14.8668 9.36395L12.9048 8.97581ZM12.1578 5.22192L13.8198 4.10928C13.3093 3.34679 12.6532 2.69072 11.8907 2.18024L10.7781 3.84217C11.3233 4.20721 11.7928 4.67666 12.1578 5.22192ZM8.97581 3.09517L9.36395 1.13319C8.9212 1.04561 8.46494 1 8 1C7.53506 1 7.0788 1.04561 6.63605 1.13319L7.02419 3.09517C7.33979 3.03273 7.66607 3 8 3C8.33393 3 8.66021 3.03273 8.97581 3.09517ZM5.22192 3.84217L4.10928 2.18024C3.34679 2.69072 2.69072 3.34679 2.18024 4.10928L3.84217 5.22192C4.20721 4.67666 4.67666 4.20721 5.22192 3.84217ZM3.09517 7.02419C3.03273 7.33979 3 7.66607 3 8C3 8.33393 3.03273 8.66021 3.09517 8.97581L1.13319 9.36395C1.04561 8.9212 1 8.46494 1 8C1 7.53506 1.04561 7.0788 1.13319 6.63605L3.09517 7.02419ZM3.84217 10.7781L2.18024 11.8907C2.69072 12.6532 3.34679 13.3093 4.10928 13.8198L5.22192 12.1578C4.67666 11.7928 4.20721 11.3233 3.84217 10.7781ZM7.02419 12.9048L6.63605 14.8668C7.0788 14.9544 7.53506 15 8 15C8.46494 15 8.9212 14.9544 9.36395 14.8668L8.97581 12.9048C8.66021 12.9673 8.33393 13 8 13C7.66607 13 7.33979 12.9673 7.02419 12.9048ZM10.7781 12.1578L11.8907 13.8198C12.6532 13.3093 13.3093 12.6532 13.8198 11.8907L12.1578 10.7781C11.7928 11.3233 11.3233 11.7928 10.7781 12.1578Z"
    />
  </svg>
  <svg
    v-if="disabled"
    :class="[
      'strike-through',
      `color-stroke-${strikeThroughColor || color}`,
      { disabled: disabled },
    ]"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="2"
    viewBox="0 0 16 2"
  >
    <path d="M0 1H16" />
  </svg>
</template>

<script setup lang="ts">
import { RbzSeriesStyle } from '../../rbz/types';

interface icon {
  color?: string;
  strikeThroughColor?: string;
  disabled?: boolean;
  circleStyle?: RbzSeriesStyle;
  bypassDefaultColor?: boolean;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
  circleStyle: 'full',
});
</script>
<style scoped lang="scss">
.strike-through {
  position: absolute;
}
</style>
